<template>
  <div v-if="subsection">
    <div v-if="!isEditMode">
      <h5 v-if="subsection.title" v-html="subsection.title"></h5>
    </div>
    <div v-else>
      <h4>Заголовок</h4>
      <b-form-input
        :value="subsection.title"
        placeholder="Введите название"
        @input="$_subsectionMixin_onTitleChange" />
      <div class="text-center mx-auto my-2">
        <b-button variant="outline-primary" @click="addFlash">
          <div v-if="!subsection.file">
            <em class="fa fa-plus mr-1"></em> Добавить flash
          </div>
          <div v-else>
            <em class="fas fa-pen mr-1"></em> Изменить flash
          </div>
        </b-button>
      </div>
      <v-modal-files-upload wrkspcType="swf"></v-modal-files-upload>
    </div>
    <div class="flash-object w-75 mx-auto" v-if="subsection.file && noUpdateFiles">
      <b-card>
        <object width="100%" height="100%">
          <param name="movie" :value="'/api/files/' + subsection.file.physicalName">
          <embed :src="'/api/files/' + subsection.file.physicalName" width="100%" height="100%">
        </object>
      </b-card>
    </div>
    <div v-if="!isEditMode">
      <div class="mt-3" v-html="editedText"></div>
    </div>
    <div v-else>
      <h4 class="mt-3">Текст</h4>
      <wysiwyg-text-editor dataType="subSectionText" />
    </div>
    <div>
      <hr noshade>
      <h5>Справка по Flash</h5>
      <div>
        <a href="https://helpx.adobe.com/ru/flash-player.html" target="_blank"><b-alert show>Нажмите для перехода по ссылке</b-alert></a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import WysiwygTextEditor from '@/components/content/edit/WysiwygTextEditor.vue'

import ContentMixin from '@/components/helpers/mixins/content-mixin'
import SubsectionMixin from '@/components/helpers/mixins/subsection-mixin'

const VModalFilesUpload = () => import('@/components/content/edit/modals/ModalFilesUpload.vue')
export default {
  name: 'FlashInfoSubSection',
  components: {
    VModalFilesUpload,
    WysiwygTextEditor
  },
  mixins: [ContentMixin, SubsectionMixin],
  props: {
    isEditMode: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.editedText = this.$_contentMixin_editCaptions(this.subsection.text)
  },
  updated() {
    this.editedText = this.$_contentMixin_editCaptions(this.subsection.text)
  },
  computed: {
    ...mapGetters({
      subsection: 'education/getSubsection'
    }),
    onUpdateFlash() {
      return (this.subsection) ? this.subsection.file : null
    }
  },
  watch: {
    onUpdateFlash() {
      if (this.$route.path === this.currentUrl && (this.currentFlash
      !== (this.subsection) ? this.subsection.file : null)) {
        this.updateUpdater()
      }
      this.currentFlash = null
      this.currentUrl = null
      this.noUpdateFiles = !this.noUpdateFiles
      this.$nextTick(() => {
        this.noUpdateFiles = !this.noUpdateFiles
      })
    }
  },
  data() {
    return {
      noUpdateFiles: true,
      currentFlash: null,
      currentUrl: null,
      editedText: ''
    }
  },
  methods: {
    ...mapActions({
      updateUpdater: 'contentManager/updateUpdater'
    }),
    addFlash() {
      this.currentFlash = (this.subsection) ? this.subsection.file : null
      this.currentUrl = this.$route.path
      this.$bvModal.show('files-upload-modal')
    }
  }
}
</script>

<style scoped>
.flash-object object{
  height: 300px;
}
</style>
